import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/2025-2026.png";

function DokumenterDelAvStrategien2026() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.strategy2026.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.strategy2026.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/2026-dokumenter-del-av-strategien"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.strategy2026.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.strategy2026.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.strategy2026.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
            <img
              src={article_img}
              className="w-full"
              alt={i18next.t("pages.articles.list.strategy2026.imageAlt")}
            />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
           
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.strategy2026.sections.s1.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.intro1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.intro2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.strategy2026.sections.s2.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s2.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s2.p2")}</p>
            
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s2.p3")} 
                {i18next.t("pages.articles.list.strategy2026.sections.s2.p4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.strategy2026.sections.s3.title")}
            </h2>
            <p className="mb-2">
                {i18next.t("pages.articles.list.strategy2026.sections.s3.p1")}
                 <br/> 
                {i18next.t("pages.articles.list.strategy2026.sections.s3.p2")}
            </p>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s3.p3")}
                <br/> {i18next.t("pages.articles.list.strategy2026.sections.s3.p4")}
            </p>
            <ul className="list-disc list-outside ml-10 my-4 space-y-2">
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s3.points.1")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s3.points.2")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s3.points.3")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s3.points.4")}</li>
            </ul>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s3.p4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.strategy2026.sections.s4.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s4.p1")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s4.p2")}</p>
            <ul className="list-disc list-outside ml-10 my-4 space-y-2">
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s4.points.1")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s4.points.2")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s4.points.3")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s4.points.4")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s4.points.5")}</li>
            </ul>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s4.p3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.strategy2026.sections.s5.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s5.p1")}</p>
            <ul className="list-disc list-outside ml-10 my-4 space-y-2">
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s5.points.1")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s5.points.2")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s5.points.3")}</li>
              <li>{i18next.t("pages.articles.list.strategy2026.sections.s5.points.4")}</li>
            </ul>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s5.p2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.strategy2026.sections.s5.p3")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DokumenterDelAvStrategien2026;


